var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleteicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1559_2270)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C5.38312 24 0 18.6169 0 12C0 5.38312 5.38312 0 12 0C18.6169 0 24 5.38308 24 12C24 18.6169 18.6169 24 12 24ZM16.6843 8.72812C16.5575 8.60148 16.3857 8.53034 16.2065 8.53034C16.0273 8.53034 15.8554 8.60148 15.7287 8.72812L10.6185 13.838L8.27156 11.4904C8.20894 11.4268 8.13434 11.3762 8.05207 11.3416C7.9698 11.307 7.88149 11.289 7.79224 11.2887C7.70298 11.2884 7.61455 11.3057 7.53204 11.3398C7.44953 11.3738 7.37458 11.4238 7.3115 11.487C7.24843 11.5501 7.19848 11.6252 7.16455 11.7077C7.13061 11.7903 7.11336 11.8787 7.11378 11.968C7.11421 12.0572 7.1323 12.1455 7.16702 12.2277C7.20174 12.31 7.25239 12.3845 7.31606 12.447L10.1408 15.2719C10.2677 15.3986 10.4397 15.4698 10.619 15.4698C10.7983 15.4698 10.9702 15.3986 11.0971 15.2719L16.6846 9.68438C16.7474 9.62161 16.7973 9.54707 16.8313 9.46501C16.8653 9.38296 16.8828 9.29501 16.8828 9.20619C16.8827 9.11737 16.8652 9.02943 16.8311 8.9474C16.7971 8.86537 16.7472 8.79085 16.6843 8.72812Z",
    fill: "#377DE2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1559_2270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleteicon);
export default __webpack_public_path__ + "static/media/completeicon.f968d270f7220aee4d73dd243b667d82.svg";
export { ForwardRef as ReactComponent };